<template>
  <div>
      <p :class="{ 'animate-font': isInViewport }" class="target-text">
        {{ message.title }}
      </p>
      <p v-show="message.content.length!=0" :class="{ 'animate-font_bnb': isInViewport }" class="target-text">
        {{ message.content }}
      </p>
  </div>
</template>

<script>
export default {
  props: {
    message: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      isInViewport: false, // 控制字体动画的布尔值
      targetElement: null, // 目标元素的引用
    };
  },
  mounted() {
    this.targetElement = this.$el.querySelector('.target-text');
    window.addEventListener('scroll', this.checkScroll);
    window.addEventListener('resize', this.checkScroll); // 可选：处理窗口大小变化
  },
  beforeDestroy() {
    window.removeEventListener('scroll', this.checkScroll);
    window.removeEventListener('resize', this.checkScroll); // 可选
  },
  methods: {
    checkScroll() {
      const rect = this.targetElement.getBoundingClientRect();
      const inViewport = (
        rect.top >= 0 &&
        rect.left >= 0 &&
        rect.bottom <= (window.innerHeight || document.documentElement.clientHeight) &&
        rect.right <= (window.innerWidth || document.documentElement.clientWidth)
      );
      this.isInViewport = inViewport;
    },
  },
};
</script>

<style scoped>
.target-text {
  font-size: 16px; /* 初始字体大小 */
  transition: font-size 0.5s ease; /* 定义过渡效果 */
}

.animate-font {
  font-size: 32px; /* 动画结束后的字体大小 */
  font-weight: 500;
  color: #0C193B;
}

.animate-font_bnb {
  font-size: 20px; /* 动画结束后的字体大小 */
  font-weight: 400;
  color: #465669;
}
</style>